// 分类名称
import javaService from "../../utils/request"
// 收藏列表
export function relatedCollection(data) {
    return javaService({
        url: '/classificationFront/relatedCollection',
        method: 'get',
        params: data,
    })
}
// 删除收藏
export function delByIds(data) {
    return javaService({
        url: '/hkCollection/delByIds/' + data,
        method: 'delete'
    })
}